import { EventStore, Override } from "@bryntum/schedulerpro";

// Todo: whenever upgrade bryntum, please run npm run test to verify this issue for regress
//https://github.com/Swivu/swivu-scheduler/pull/1185
Override.apply(class {
  static target = {
    class: EventStore,
    product: "schedulerpro",
    minVersion: "7.0.0",
    maxVersion: "7.3.5"
  }

  onBeforeRemoveAssignment({ records }) {
        const me = this;

        if (
            me.removeUnassignedEvent && !me.isRemoving && !me.isSettingData &&
            !me.stm?.isRestoring && !me.usesSingleAssignment &&
            !me.assignmentStore.isSyncingDataOnLoad && !me.resourceStore.isSyncingDataOnLoad
        ) {
            const toRemove = new Set();
            // Collect all events that are unassigned after the remove
            records.forEach(assignmentRecord => {
                const { event } = assignmentRecord;
                // PATCH
                if (event && !event.isRemoved && me.assignmentStore.query(r => r.eventId === event.id).every(a => records.includes(a))) {
                // END PATCH
                // WAS
                // if (event && !event.isRemoved && event.assignments.every(a => records.includes(a))) {
                // END WAS
                    toRemove.add(event);
                }
            });

            // And remove them
            if (toRemove.size) {
                me.remove([...toRemove]);
            }
        }
    }
})
